import { useGetContactInfo } from "api/common/useGetContactInfo";

/**
 * FA external contactId of the Borea representative contact. Internal Borea
 * users have their Keycloak user linked to this contact, which represents all
 * clients in the system and grants access to the advisor page (Rådgiverside).
 */
export const BOREA_REP_CONTACT_ID = "BoreaREP";

/**
 * Whether the logged-in user is a Borea representative, i.e. their *linked*
 * contact (not the currently selected client) is the BoreaREP contact.
 * Reads the linked contact via useGetContactInfo() without an explicit id, so
 * the result is stable regardless of which client is selected.
 */
export const useIsBoreaRep = () => {
  const { data } = useGetContactInfo();
  return data?._contactId === BOREA_REP_CONTACT_ID;
};
